import loadable from '@loadable/component';

// Non-Lazy Page Components
import HomePage from '/views/pages/home';
import PlaceOrderPage from '/views/pages/place-order';
import MenuPage from '/views/pages/menu';
import BasketPage from '/views/pages/basket';
import LoginPage from '/views/pages/login';

export default {
	home: {
		path: '/',
		exact: true,
		layout: 'raw',
		layoutClass: 'home',
		allowWeb: false,
		component: HomePage,
	},
	webLanding: {
		path: '/navigasyon',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-landing',
		disallowApp: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-landing')),
	},
	placeOrder: {
		path: '/siparis-ver',
		exact: true,
		layout: 'raw',
		layoutClass: 'place-order',
		allowWeb: false,
		component: PlaceOrderPage,
	},
	menu: {
		path: '/mobil-menu',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu',
		allowWeb: false,
		component: MenuPage,
	},
	menuCategory: {
		path: '/mobil-menu/kategori/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu-category',
		allowWeb: false,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/menu-category')),
	},
	menuSearch: {
		path: '/mobil-menu/arama/:query?',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu-search',
		allowWeb: false,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/menu-search')),
	},
	menuProduct: {
		path: '/mobil-menu/urun/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'menu-product',
		allowWeb: false,
		hideNav: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/menu-product')),
	},
	webMenuLanding: {
		path: '/menu/:branchSlug/:tableId?',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu')),
	},
	webMenu: {
		path: '/menu/kategori/goster/:branchSlug/:tableId?',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu')),
	},
	webMenuCategory: {
		path: '/menu/:branchSlug/kategori/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu-category',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu-category')),
	},
	webMenuProduct: {
		path: '/menu/:branchSlug/urun/:id',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-menu-product',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-menu-product')),
	},
	orderLookup: {
		path: '/mobil-siparis-sorgula',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-order-lookup',
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/order-lookup')),
	},
	webOrderLookup: {
		path: '/siparis-sorgula',
		exact: true,
		layout: 'raw',
		layoutClass: 'web-order-lookup',
		allowWeb: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/web-order-lookup')),
	},
	promotions: {
		path: '/promosyonlar',
		exact: true,
		layout: 'raw',
		layoutClass: 'promotions',
		allowWeb: false,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/promotions')),
	},
	basket: {
		path: '/sepet',
		exact: true,
		layout: 'raw',
		layoutClass: 'basket',
		allowWeb: false,
		hideNav: true,
		component: BasketPage,
	},
	payment: {
		path: '/sepet/odeme/:orderId',
		requiresLogin: true,
		exact: true,
		layout: 'raw',
		layoutClass: 'payment',
		allowWeb: false,
		hideNav: true,
		disableServerCache: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/payment')),
	},
	orderSummary: {
		path: '/sepet/odeme/basarili/:orderId',
		requiresLogin: true,
		exact: true,
		layout: 'raw',
		layoutClass: 'order-summary',
		allowWeb: false,
		disableServerCache: true,
		component: loadable(() => import(/* webpackPrefetch: true */ '/views/pages/order-summary')),
	},
	login: {
		path: '/giris-yap',
		exact: true,
		layout: 'raw',
		layoutClass: 'login',
		allowWeb: false,
		hideNav: true,
		component: LoginPage,
	},
	account: {
		path: '/hesabim',
		requiresLogin: true,
		redirect: {
			key: 'account.nav',
			params: {},
		},
		children: {
			nav: {
				path: '/hesabim/menu',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-nav',
				allowWeb: false,
				requiresLogin: true,
				component: loadable(() => import('/views/pages/account/nav')),
			},
			info: {
				path: '/hesabim/bilgilerim',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-info',
				allowWeb: false,
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/info')),
			},
			paymentMethods: {
				path: '/hesabim/odeme-yontemleri',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-payment-methods',
				allowWeb: false,
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/payment-methods')),
			},
			orders: {
				path: '/hesabim/gecmis-siparisler',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-orders',
				allowWeb: false,
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/orders')),
			},
			lottery: {
				path: '/hesabim/cekilis',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-lottery',
				allowWeb: false,
				requiresLogin: true,
				hideNav: true,
				component: loadable(() => import('/views/pages/account/lottery')),
			},
			orderDetail: {
				path: '/hesabim/gecmis-siparisler/:id',
				exact: true,
				layout: 'raw',
				layoutClass: 'account-order-detail',
				allowWeb: false,
				requiresLogin: true,
				hideNav: true,
				disableServerCache: true,
				component: loadable(() => import('/views/pages/account/order-detail')),
			},
		},
	},
	dataRemoval: {
		path: '/veri-silme-talebi',
		exact: true,
		layout: 'raw',
		layoutClass: 'data-removal',
		component: loadable(() => import(/* webpackPrefetch: false */ '/views/pages/data-removal')),
	},
	notFound: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-not-found',
		status: 404,
		head: {
			title: 'Sayfa Bulunamadı',
		},
		component: loadable(() => import('/views/pages/not-found')),
	},
	error: {
		path: '*',
		layout: 'raw',
		layoutClass: 'error type-error',
		status: 500,
		head: {
			title: 'Bir Hata İle Karşılaşıldı',
		},
		component: loadable(() => import('/views/pages/error')),
	},
};
